import React, { useState } from "react";

import TileChart from "./Components/TileChart/TileChart";
import Preview from "./Components/Preview/Preview";
import LayoutWarning from "./Components/LayoutWarning/LayoutWarning";
import NoChartsMessage from "./Components/NoChartsMessage/NoChartsMessage";

import { StyledMainChartContainer } from "./MainChartContainerStyles";
import { useChartList } from "./hooks/useChartList";
import LayoutManager from "./Components/LayoutManager/LayoutManager";
import ChartInterfaceToolbar from "../DetectionPreviewToolbar/ChartInterfaceToolbar";
import ColdStartLoader from "../DetectionPreviewColdStart/ColdStartLoader/ColdStartLoader";

export default function MainChartContainer({ show }) {
  const chartList = useChartList();

  // useState hooks
  const [loading, setLoading] = useState(false);

  return (
    <StyledMainChartContainer show={show} id="main-chart-container">
      {loading ? (
        <ColdStartLoader />
      ) : (
        <>
          <ChartInterfaceToolbar setLoading={setLoading} />
          <LayoutManager show={show} containerId="main-chart-container">
            {chartList
              .filter((chart) => !chart.isMinimized)
              .map((chart) => {
                if (chart.key === "preview") {
                  return (
                    <div key={chart.key}>
                      <Preview
                        fullScreenChart={chart.fullScreenChart}
                        containerId={"preview_container"}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div key={chart.key}>
                      <TileChart
                        chartId={chart.key}
                        isFullScreen={chart.isFullScreen}
                        isMinimized={chart.isMinimized}
                        prefix={"tile_chart"}
                      />
                    </div>
                  );
                }
              })}
          </LayoutManager>
          {!chartList.length && <NoChartsMessage />}
          <LayoutWarning />
        </>
      )}
    </StyledMainChartContainer>
  );
}
